import Cross from '../../assets/cross';
import { Button, Drawer, Input } from 'antd';
import * as React from 'react';
import withStyles from 'react-jss';
import { StylesProps } from '../../theme/jss-types';
import { trackingStyles } from './track-consignment.styles';
import ConsignmentTracking from '../consignments/consignment-tracking';
import { useTranslation } from 'react-i18next';
import { TrackTypeEnum } from 'types/view.types';
import useIsMobile from 'hooks/useIsMobile';

interface TrackConsignmentProps extends StylesProps<ReturnType<typeof trackingStyles>> {
    onClose: () => void;
    referenceNumber?: string;
    trackType?: string;
}

const isTrackTypeEnum = (value: any): value is TrackTypeEnum => {
    return Object.values(TrackTypeEnum).includes(value);
};

const TrackConsignment = (props: TrackConsignmentProps) => {
    const {
        classes,
        onClose,
        referenceNumber,
        trackType,
    } = props;

    const isMobile = useIsMobile();
    const { t } = useTranslation();
    const [reference, setReference] = React.useState<string | undefined>(referenceNumber);
    const [toggle, setToggle] = React.useState<boolean>(true);

    const getTextForTrackType = (type: string | undefined, defaultKey: string, keys: Record<string, string>) => {
        return type && isTrackTypeEnum(type) ? t(keys[type] || defaultKey) : t(defaultKey);
    };

    const validTrackType = isTrackTypeEnum(trackType) ? trackType : undefined;

    const headerText = getTextForTrackType(validTrackType, 'track_consignment', {
        [TrackTypeEnum.CUSTOMER_REFERENCE_NO]: 'track_customer_reference_number',
        [TrackTypeEnum.CARRIER_AWB_NUMBER]: 'track_carrier_awb_number',
    });
    const placeHolder = headerText;
    const resultText = getTextForTrackType(validTrackType, 'track_consignment', {
        [TrackTypeEnum.CUSTOMER_REFERENCE_NO]: 'tracking_customer_reference_result_text',
        [TrackTypeEnum.CARRIER_AWB_NUMBER]: 'tracking_carrier_awb_number_result_text',
    });

    const renderHeader = () => {
        return (
            <div className={classes.header}>
                <div className={classes.addText}>
                    <Cross onClick={() => onClose()} alt="close" className={classes.closeIcon} />
                    <span>
                        {headerText}
                    </span>
                </div>
            </div>
        );
    };

    const renderTrackInputs = () => {
        return (
            <div className={classes.inputs}>
                <Input
                    value={reference}
                    placeholder={placeHolder}
                    className={classes.input}
                    onChange={(e) => setReference(e.target.value)}
                    style={{ width: '74%' }}
                />
                <Button
                    type="primary"
                    onClick={() => setToggle(!toggle)}
                    disabled={!reference}
                >
                    {t('track')}
                </Button>
            </div>
        );
    };

    const renderAvailabilityText = () => {
        return (
            <div className={classes.trackText}>
                <div className={classes.flexRow}>
                    <span className={classes.availableText}>
                        {resultText}
                    </span>
                    <span className={classes.reference}>{reference}</span>
                </div>
                {/* <Button type="link">View Details</Button> */}
            </div>
        );
    };

    const renderBody = () => {
        return (
            <div className={classes.body}>
                {renderAvailabilityText()}
            </div>
        );
    };

    const renderTracking = () => {
        return (
            <ConsignmentTracking
                dontShowTitle
                toggle={toggle}
                referenceNumber={reference}
                trackType={trackType}
            />
        );
    };

    return (
        <Drawer
            visible
            width={isMobile ? '100%' : '28%'}
            title={renderHeader()}
            onClose={() => onClose()}
            className={classes.main}
            closable={false}
        >
            {renderTrackInputs()}
            {renderBody()}
            {renderTracking()}
        </Drawer>
    );
};

export default withStyles(trackingStyles)(TrackConsignment);
